<template>
  <section class="py-5  bg-gray-200">

    <div class="container ">
      <div class="row justify-content-center text-center">
        <div class="col-lg-8">
          <div>
            <h4 class="fw-bold text-primary-400 mb-5">
              L'indagine censisce i <span class="text-primary">300 Enti filantropici</span> e gli <span
                class="text-primary">Altri ETS iscritti
              al RUNTS </span>che operano nell’ambito
              della filantropia, per comprendere:
            </h4>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <ul class="list-unstyled">
            <li v-for="obj in objective" class="pb-3 h6">
              <div class="d-flex">
                <i class="las la-check-square text-primary-400 la-lg"></i>
                <div class="ms-3">{{ obj }}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container ">
      <div class="bg-primary-light text-center  p-3 p-lg-5">
        <div class="">
          <h4 class="fw-bold text-primary-400 ">
            Tra gli Enti che hanno aderito:
          </h4>
        </div>
      </div>
      <div class="bg-white">
        <div class="row g-0">
          <div class="col-lg-12 ">
            <div class="row pb-5 px-lg-5 p-3">
              <div class="col-6 col-md-3" v-for="logo in loghi">
                <div class="p-md-4 p-2">
                  <img class="img-fluid"
                       :src="`${runtimeConfig.public.cdnURL}/images/loghi-ets/${logo.src}`"
                       alt="">
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="text-center bg-primary-light p-3 p-lg-5">
        <h4 class="fw-bold mb-3 text-primary-400">
          Vuoi entrare a far parte della rete?
        </h4>
        <button class="btn btn-primary btn-cta" @click="openPromoterModal">Aderisci</button>
      </div>
    </div>

  </section>

</template>
<script setup lang="ts">
const {$event} = useNuxtApp();
const openPromoterModal = (action, value) => {
  $event('modal:promoter', {action, value});
};

const runtimeConfig = useRuntimeConfig();

const objective = [
  "Le opinioni sui benefici, sulle opportunità e sulle aspettative dell'essere iscritti al RUNTS",
  "La natura della mission filantropica e le traiettorie di sviluppo delle azioni a impatto",
  "La varietà delle connessioni e sinergie con stakeholder e beneficiari",
  "Le sfide in corso e le proposte di miglioramento per il futuro del settore",
]

const loghi = [
  {src: "_0000_bambin-gesu.png"},
  {src: "_0015_fondazione-mazzola.png"},
  {src: "_0001_associazione-pazienti.png"},
  {src: "_0002_munus-parma.png"},
  {src: "_0003_sanitansable.png"},
  {src: "_0004_AISTAP_ETSN.png"},
  {src: "_0005_global-thinking.png"},
  {src: "_0006_logo-fondazione-veronede.png"},
  {src: "_0007_fondazione-tina-anselmi.png"},
  {src: "_0008_fondazione-san-gennaro.png"},
  {src: "_0009_fondazione-vco.png"},
  {src: "_0010_direttamente.png"},
  {src: "_0011_fondazione-sidival-fila.png"},
  {src: "_0012_fondazione-vanesio.png"},
  {src: "_0013_fondazione-una.png"},
  {src: "_0014_fondazione-isola-delba-ets.png"},
  {src: "_0016_fondazione-valsesia.png"},
  {src: "_0017_alba-nostra.png"},
  {src: "_0003_dallara.png"},
  {src: "_0002_fondazionepetrucco.png"},
  {src: "_0001_fondazione-san-giovanni-battista.png"},
  {src: "cop.png"},
]


</script>